<div class="content-heading header d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center">
        <div class="back-icon text-primary pointer" (click)="cancel()">
            <em class="fas fa-arrow-left"></em>
            <ng-content select="h-left"></ng-content>
        </div>
        <div class="project-detail mr-5 d-flex flex-column">
            <div class="title text-primary">
                <ng-content select="title"></ng-content>
            </div>
            <div class="d-flex creation-date central-content">
                <div class="g1">
                    <ng-content select="column-1"></ng-content>
                </div>
                <div class="g1">
                    <ng-content select="column-2"></ng-content>
                </div>
            </div>
        </div>
    </div>
    <div class="d-flex align-items-right g-10">
        <ng-content class="g-10" select="grp1-right"></ng-content>
        <ng-content class="g-10" select="grp2-right"></ng-content>
    </div>

</div>